/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const USER_UPSERT_REQUEST = 'USER_ADD_REQUEST';
export const USER_UPSERT_REQUEST_SUCCESS = 'USER_ADD_REQUEST_SUCCESS';
export const USER_UPSERT_REQUEST_FAILURE = 'USER_ADD_REQUEST_FAILURE';

export const USER_FETCH_REQUEST = 'USER_FETCH_REQUEST';
export const USER_FETCH_REQUEST_SUCCESS = 'USER_FETCH_REQUEST_SUCCESS';
export const USER_FETCH_REQUEST_FAILURE = 'USER_FETCH_REQUEST_FAILURE';

export const CHANGE_USER_PASSWORD_REQUEST = 'CHANGE_USER_PASSWORD_REQUEST';
export const CHANGE_USER_PASSWORD_REQUEST_SUCCESS = 'CHANGE_USER_PASSWORD_REQUEST_SUCCESS';
export const CHANGE_USER_PASSWORD_REQUEST_FAILURE = 'CHANGE_USER_PASSWORD_REQUEST_FAILURE';

export const USER_CLEAN_REQUEST = 'USER_CLEAN_REQUEST';

export const USER_DROPDOWN_CLIENT_REQUEST = 'USER_DROPDOWN_CLIENT_REQUEST';

export const ALL_USER_FETCH_REQUEST = 'ALL_USER_FETCH_REQUEST';
export const ALL_USER_FETCH_REQUEST_SUCCESS = 'ALL_USER_FETCH_REQUEST_SUCCESS';
export const ALL_USER_FETCH_REQUEST_FAILURE = 'ALL_USER_FETCH_REQUEST_FAILURE';

export const USER_SERVICES_ADD_REQUEST = 'USER_SERVICES_ADD_REQUEST';
export const USER_SERVICES_ADD_REQUEST_SUCCESS = 'USER_SERVICES_ADD_REQUEST_SUCCESS';
export const USER_SERVICES_ADD_REQUEST_FAILURE = 'USER_SERVICES_ADD_REQUEST_FAILURE';

export const USER_SERVICES_FETCH_REQUEST = 'USER_SERVICES_FETCH_REQUEST';
export const USER_SERVICES_FETCH_REQUEST_SUCCESS = 'USER_SERVICES_FETCH_REQUEST_SUCCESS';
export const USER_SERVICES_FETCH_REQUEST_FAILURE = 'USER_SERVICES_FETCH_REQUEST_FAILURE';

export const USER_UPSERT_WORKING_HOUR_REQUEST = 'USER_UPSERT_WORKING_HOUR_REQUEST';
export const USER_UPSERT_WORKING_HOUR_REQUEST_SUCCESS = 'USER_UPSERT_WORKING_HOUR_REQUEST_SUCCESS';
export const USER_UPSERT_WORKING_HOUR_REQUEST_FAILURE = 'USER_UPSERT_WORKING_HOUR_REQUEST_FAILURE';

export const USER_FETCH_WORKING_HOUR_REQUEST = 'USER_FETCH_WORKING_HOUR_REQUEST';
export const USER_FETCH_WORKING_HOUR_REQUEST_SUCCESS = 'USER_FETCH_WORKING_HOUR_REQUEST_SUCCESS';
export const USER_FETCH_WORKING_HOUR_REQUEST_FAILURE = 'USER_FETCH_WORKING_HOUR_REQUEST_FAILURE';

export const USER_UPSERT_BREAK_REQUEST = 'USER_UPSERT_BREAK_REQUEST';
export const USER_UPSERT_BREAK_REQUEST_SUCCESS = 'USER_UPSERT_BREAK_REQUEST_SUCCESS';
export const USER_UPSERT_BREAK_REQUEST_FAILURE = 'USER_UPSERT_BREAK_REQUEST_FAILURE';

export const USER_FETCH_BREAK_REQUEST = 'USER_FETCH_BREAK_REQUEST';
export const USER_FETCH_BREAK_REQUEST_SUCCESS = 'USER_FETCH_BREAK_REQUEST_SUCCESS';
export const USER_FETCH_BREAK_REQUEST_FAILURE = 'USER_FETCH_BREAK_REQUEST_FAILURE';

export const USER_UPSERT_TIME_OFF_REQUEST = 'USER_UPSERT_TIME_OFF_REQUEST';
export const USER_UPSERT_TIME_OFF_REQUEST_SUCCESS = 'USER_UPSERT_TIME_OFF_REQUEST_SUCCESS';
export const USER_UPSERT_TIME_OFF_REQUEST_FAILURE = 'USER_UPSERT_TIME_OFF_REQUEST_FAILURE';

export const USER_FETCH_TIME_OFF_REQUEST = 'USER_FETCH_TIME_OFF_REQUEST';
export const USER_FETCH_TIME_OFF_REQUEST_SUCCESS = 'USER_FETCH_TIME_OFF_REQUEST_SUCCESS';
export const USER_FETCH_TIME_OFF_REQUEST_FAILURE = 'USER_FETCH_TIME_OFF_REQUEST_FAILURE';

export const USER_CHECK_TIME_OFF_REQUEST = 'USER_CHECK_TIME_OFF_REQUEST';
export const USER_CHECK_TIME_OFF_REQUEST_SUCCESS = 'USER_CHECK_TIME_OFF_REQUEST_SUCCESS';
export const USER_CHECK_TIME_OFF_REQUEST_FAILURE = 'USER_CHECK_TIME_OFF_REQUEST_FAILURE';

export const USER_CHECK_TIME_OFF_CLEAN_REQUEST = 'USER_CHECK_TIME_OFF_CLEAN_REQUEST';

export const USER_APPOINTMENT_POLICY_FETCH_REQUEST = 'USER_APPOINTMENT_POLICY_FETCH_REQUEST';
export const USER_APPOINTMENT_POLICY_FETCH_REQUEST_SUCCESS =
  'USER_APPOINTMENT_POLICY_FETCH_REQUEST_SUCCESS';
export const USER_APPOINTMENT_POLICY_FETCH_REQUEST_FAILURE =
  'USER_APPOINTMENT_POLICY_FETCH_REQUEST_FAILURE';

export const USER_APPOINTMENT_POLICY_UPSERT_REQUEST = 'USER_APPOINTMENT_POLICY_UPSERT_REQUEST';
export const USER_APPOINTMENT_POLICY_UPSERT_REQUEST_SUCCESS =
  'USER_APPOINTMENT_POLICY_UPSERT_REQUEST_SUCCESS';
export const USER_APPOINTMENT_POLICY_UPSERT_REQUEST_FAILURE =
  'USER_APPOINTMENT_POLICY_UPSERT_REQUEST_FAILURE';

export const TAX_REPRESENTATIVE_FETCH_REQUEST = 'TAX_REPRESENTATIVE_FETCH_REQUEST';
export const TAX_REPRESENTATIVE_FETCH_REQUEST_SUCCESS = 'TAX_REPRESENTATIVE_FETCH_REQUEST_SUCCESS';
export const TAX_REPRESENTATIVE_FETCH_REQUEST_FAILURE = 'TAX_REPRESENTATIVE_FETCH_REQUEST_FAILURE';

export const USER_PREFERENCE_FETCH_REQUEST = 'USER_PREFERENCE_FETCH_REQUEST';
export const USER_PREFERENCE_FETCH_REQUEST_SUCCESS = 'USER_PREFERENCE_FETCH_REQUEST_SUCCESS';
export const USER_PREFERENCE_FETCH_REQUEST_FAILURE = 'USER_PREFERENCE_FETCH_REQUEST_FAILURE';

export const USE_PREFERENCE_CLEAN_REQUEST = 'USE_PREFERENCE_CLEAN_REQUEST';

export const USER_MEMBERS_FETCH_REQUEST = 'USER_MEMBERS_FETCH_REQUEST';
export const USER_MEMBERS_FETCH_REQUEST_SUCCESS = 'USER_MEMBERS_FETCH_REQUEST_SUCCESS';
export const USER_MEMBERS_FETCH_REQUEST_FAILURE = 'USER_MEMBERS_FETCH_REQUEST_FAILURE';

export const USER_MEMBERS_LINK_REQUEST = 'USER_MEMBERS_LINK_REQUEST';
export const USER_MEMBERS_LINK_REQUEST_SUCCESS = 'USER_MEMBERS_LINK_REQUEST_SUCCESS';
export const USER_MEMBERS_LINK_REQUEST_FAILURE = 'USER_MEMBERS_LINK_REQUEST_FAILURE';

export const SWITCHABLE_PROFILES_FETCH_REQUEST = 'SWITCHABLE_PROFILES_FETCH_REQUEST';
export const SWITCHABLE_PROFILES_FETCH_REQUEST_SUCCESS =
  'SWITCHABLE_PROFILES_FETCH_REQUEST_SUCCESS';
export const SWITCHABLE_PROFILES_FETCH_REQUEST_FAILURE =
  'SWITCHABLE_PROFILES_FETCH_REQUEST_FAILURE';

export const SWITCH_MEMBER_PROFILE_REQUEST = 'SWITCH_MEMBER_PROFILE_REQUEST';
export const SWITCH_MEMBER_PROFILE_REQUEST_SUCCESS = 'SWITCH_MEMBER_PROFILE_REQUEST_SUCCESS';
export const SWITCH_MEMBER_PROFILE_REQUEST_FAILURE = 'SWITCH_MEMBER_PROFILE_REQUEST_FAILURE';

export const USER_TAB_PROPS_CLEAN_REQUEST = 'USER_TAB_PROPS_CLEAN_REQUEST';
export const CLEAN_USER_MEMBERS_LINK_PROPS = 'CLEAN_USER_MEMBERS_LINK_PROPS';
export const USER_TAB_ERROR_PROPS_CLEAN_REQUEST = 'USER_TAB_ERROR_PROPS_CLEAN_REQUEST';

export const TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST =
  'TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST';
export const TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST_SUCCESS =
  'TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST_SUCCESS';
export const TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST_FAILURE =
  'TAX_REPRESENTATIVE_REASSIGN_UPDATE_REQUEST_FAILURE';
